// extracted by mini-css-extract-plugin
export var boldText = "_8a-4";
export var checkboxContainer = "_8a-6";
export var closeIcon = "_8a-i";
export var container = "_8a-0";
export var drawer = "_8a-8";
export var drawerContent = "_8a-9";
export var extraSmallText = "_8a-5";
export var fulfillmentGroupTable = "_8a-e";
export var largeText = "_8a-3";
export var loadingSpinnerContainer = "_8a-j";
export var mediumText = "_8a-2";
export var narrow = "_8a-f";
export var notificationLink = "_8a-l";
export var packageCheckIconContainer = "_8a-7";
export var slideoutHeaderActions = "_8a-g";
export var slideoutHeaderActionsShifted = "_8a-h";
export var slideoutHeaderContainer = "_8a-a";
export var slideoutModal = "_8a-c";
export var stickyHeaderWrapper = "_8a-b";
export var table = "_8a-k";
export var tableContainer = "_8a-d";
export var tertiaryText = "_8a-1";